// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-j_gL","catalogByServiceItem__title":"c-j_gM"};